import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const useUTC = () => {
    /**
     * @param {string} date
     * @returns {string}
     */
    function toUTC(date) {
        // Match the DateTime::ATOM format used in PHP (2022-07-06T00:00:00+00:00).
        return formatInTimeZone(
            parseISO(date),
            "GMT",
            "yyyy-MM-dd'T'HH:mm:ssxxx"
        );
    }

    /**
     * @param {string} date
     * @returns {Date}
     */
    function fromUTC(date) {
        // Date will automatically convert the given UTC date to the local timezone.
        return new Date(date);
    }

    return {
        toUTC,
        fromUTC,
    };
};
